import React, { useState, useEffect, useMemo } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Drawer, Checkbox, Spin, Space, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useGetCampaignMappingDropdownsWithOptionsQuery } from "../../redux/api/campaignMappings";
import { setSelectedCustomConfigNames } from "../../redux/store/campaignMappingsSlice";

const CustomCategoryDrawer = () => {

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name'] || '');
    const selectedCampaignMappingConfigName = useSelector((state) => state.genericReporting.selectedDropdownValues['campaign_mapping_config_name'] || '');
    const savedSelectedConfigNames = useSelector((state) => state.campaignMappingsUi.selectedCustomConfigNames || []);
    const [checkedConfigNames, setCheckedConfigNames] = useState(
        selectedCampaignMappingConfigName ? [selectedCampaignMappingConfigName] : []
    );

    const { data, isFetching } = useGetCampaignMappingDropdownsWithOptionsQuery(
        { clientName: selectedClient },
        { skip: !open || !selectedClient }
    );

    // Only configs are selectable; derive config list

    const configOptions = useMemo(() => {
        if (!Array.isArray(data)) return [];
        return Array.from(new Set(data.map((d) => d?.config_name).filter(Boolean)));
    }, [data]);

    useEffect(() => {
        if (open) {
            setCheckedConfigNames(
                (savedSelectedConfigNames && savedSelectedConfigNames.length > 0)
                    ? savedSelectedConfigNames
                    : (selectedCampaignMappingConfigName ? [selectedCampaignMappingConfigName] : [])
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const handleSave = () => {
        dispatch(setSelectedCustomConfigNames(checkedConfigNames));
        setOpen(false);
    };

    return (
        <div>
            <Button type="secondary" icon={<PlusOutlined />} onClick={() => setOpen(true)}></Button>
            <Drawer title="Add Custom Category" open={open} onClose={() => setOpen(false)}>
                {isFetching ? (
                    <Spin />
                ) : (
                    <div>
                        {configOptions.length > 0 && (
                            <div style={{ marginBottom: 12 }}>
                                <Typography.Text strong>Configs</Typography.Text>
                                <div style={{ marginTop: 8 }}>
                                    <Checkbox.Group
                                        options={configOptions.map((name) => ({ label: name, value: name }))}
                                        value={checkedConfigNames}
                                        onChange={(vals) => setCheckedConfigNames(vals)}
                                    />
                                </div>
                            </div>
                        )}
                        {/* Only configs are selectable; categories removed per request */}
                        <div style={{ marginTop: 16 }}>
                            <Space>
                                <Button onClick={() => setOpen(false)}>Cancel</Button>
                                <Button type="primary" onClick={handleSave} disabled={!selectedClient}>Save</Button>
                            </Space>
                        </div>
                    </div>
                )}
            </Drawer>
        </div>
    )

}

export default CustomCategoryDrawer;